// 약관 동의 목록 — 가입/동의 화면에서 공용으로 쓴다
import type { AgreementInput, TermsItem } from "@taplink/web-shared";

interface Props {
  terms: TermsItem[];
  checked: Record<string, boolean>;
  onChange: (code: string, value: boolean) => void;
}

export function TermsCheckList({ terms, checked, onChange }: Props) {
  const allChecked = terms.length > 0 && terms.every((t) => checked[t.code]);

  const toggleAll = (value: boolean) => {
    terms.forEach((t) => onChange(t.code, value));
  };

  return (
    <fieldset style={{ border: "1px solid var(--border)", borderRadius: 8, padding: "0.75rem 1rem" }}>
      <legend style={{ fontWeight: 600, fontSize: "0.9rem" }}>약관 동의</legend>

      <div className="terms-item">
        <input
          id="terms-all"
          type="checkbox"
          checked={allChecked}
          onChange={(e) => toggleAll(e.target.checked)}
        />
        <label htmlFor="terms-all" style={{ fontWeight: 700 }}>전체 동의</label>
      </div>

      {terms.map((term) => (
        <div className="terms-item" key={term.code}>
          <input
            id={`terms-${term.code}`}
            type="checkbox"
            checked={checked[term.code] ?? false}
            onChange={(e) => onChange(term.code, e.target.checked)}
            aria-required={term.required}
          />
          <label htmlFor={`terms-${term.code}`}>
            {/* ⚠️ 필수와 선택은 **다른 클래스**를 쓴다. 예전에는 둘 다 required-badge 라
                선택 항목까지 경고색이 붙었다 — 색이 정반대 뜻을 전달했다.
                뜻은 글자("[필수]"/"[선택]")가 지고 색은 거들 뿐이다(KWCAG: 색만으로 전달 금지). */}
            <span className={term.required ? "required-badge" : "optional-badge"}>
              {term.required ? "[필수]" : "[선택]"}
            </span>
            {term.title}
            {term.contentUrl && (
              <>
                {" "}
                <a href={term.contentUrl} target="_blank" rel="noreferrer">전문 보기</a>
              </>
            )}
          </label>
        </div>
      ))}
    </fieldset>
  );
}

/** 체크 상태를 API 요청 형태로 변환 */
export function toAgreements(terms: TermsItem[], checked: Record<string, boolean>): AgreementInput[] {
  return terms.map((t) => ({
    code: t.code,
    version: t.version,
    agreed: checked[t.code] ?? false,
  }));
}

/** 필수 약관을 모두 동의했는지 */
export function requiredSatisfied(terms: TermsItem[], checked: Record<string, boolean>): boolean {
  return terms.filter((t) => t.required).every((t) => checked[t.code]);
}
